export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于51每日大赛
          </h2>
        </div>

        <div className="max-w-4xl">
          <div className="bg-background-50 border border-background-200 rounded-xl p-6 md:p-10">
            <div className="prose prose-sm max-w-none">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                51每日大赛成立于2023年，是国内领先的吃瓜爆料内容聚集平台。我们致力于为广大吃瓜爱好者提供最新、最全、最真实的热门事件追踪和深度爆料内容。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                平台每日更新来自娱乐圈、直播圈、网红圈、体育圈、科技圈等各领域的实时吃瓜资讯，覆盖明星塌房、网红翻车、综艺名场面、品牌解约等热门话题。所有内容均来源于公开报道和网友投稿，平台坚持客观呈现，不做主观评判。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                我们的使命是打造最活跃的吃瓜社区，让每一位瓜友都能在这里找到感兴趣的内容。目前51每日大赛已覆盖Web端、iOS和Android移动端，日活跃用户超过千万，是国内吃瓜文化的核心阵地。
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
                {[
                  { value: '3年+', label: '稳定运营' },
                  { value: '千万+', label: '日活用户' },
                  { value: '10万+', label: '累计爆料' },
                  { value: '7×24h', label: '实时更新' },
                ].map((s) => (
                  <div key={s.label} className="text-center py-3 px-2 bg-background-100 rounded-lg">
                    <div className="text-lg md:text-xl font-heading font-bold text-accent-600">{s.value}</div>
                    <div className="text-xs text-foreground-500 mt-1">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}